import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Card, CardContent } from '../ui/card';

ChartJS.register(ArcElement, Tooltip, Legend);

const EmailDeliveryTile = () => {
  const [data, setData] = useState({ sent: 0, bounced: 0, successRate: '0.00' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/superadmin-stats/email-delivery`, {
          withCredentials: true,
        });
        setData(res.data);
      } catch (err) {
        console.error('Fehler beim Abrufen der E-Mail-Daten:', err);
      }
    };
    fetchData();
  }, []);

  const total = data.sent + data.bounced;

  const chartData = {
    labels: ['Erfolgreich', 'Gebounct'],
    datasets: [
      {
        data: [data.sent, data.bounced],
        backgroundColor: ['#22c55e', '#f87171'],
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: '#ccc',
        },
      },
    },
  };

  return (
    <Card className="h-full">
      <CardContent className="p-6">
        <h3 className="text-sm text-gray-400">E-Mail-Zustellung</h3>
        <p className="text-2xl font-bold mt-2">{data.sent} / {total}</p>
        <p className="text-sm text-gray-400 mb-4">Bounce: {data.bounced} &nbsp;•&nbsp; Erfolgsquote: {data.successRate} %</p>
        <div className="w-full h-48">
          <Doughnut data={chartData} options={chartOptions} />
        </div>
      </CardContent>
    </Card>
  );
};

export default EmailDeliveryTile;
